import { api } from '../createApi';
import { TagType } from '../TagType';

const TAG_BY_LIST = { type: TagType.Playbooks, id: 'LIST' };
const TAG_BY_LIST_GUIDELINES = { type: TagType.Guidelines, id: 'LIST' };
const TAG_TEMPLATES_BY_LIST = { type: TagType.PlaybookTemplates, id: 'LIST' };

api.enhanceEndpoints({
  addTagTypes: [
    TagType.Playbooks as TagType,
    TagType.PlaybookTemplates as TagType,
  ],
  endpoints: {
    getPlaybooks: {
      providesTags: [TAG_BY_LIST],
    },
    getPlaybook: {
      providesTags: (_result, _error, arg) => [
        { type: TagType.Playbooks, id: arg.playbookId },
      ],
    },
    createPlaybook: {
      invalidatesTags: [TAG_BY_LIST, TAG_BY_LIST_GUIDELINES],
    },
    updatePlaybook: {
      invalidatesTags: (_result, _error, arg) => [
        { type: TagType.Playbooks, id: arg.playbookId },
        TAG_BY_LIST,
        TAG_BY_LIST_GUIDELINES,
      ],
    },
    deletePlaybook: {
      invalidatesTags: [TAG_BY_LIST, TAG_BY_LIST_GUIDELINES],
    },
    getPlaybookTemplates: {
      providesTags: [TAG_TEMPLATES_BY_LIST],
    },
    getPlaybookTemplate: {
      providesTags: (_result, _error, arg) => [
        { type: TagType.PlaybookTemplates, id: arg.templateId },
      ],
    },
  },
});
